/* eslint-disable */

import { post } from '../../http/restservice'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { usePaymentProcessingTimer } from '../../hooks/useProcessingTimer'
import { Progress } from '../../Components/ui/progress'
import PaymentStatusModal from '../../Components/modals/OneTimePayment'
import env from '../../env/env'

const POLL_INTERVAL = 10000 // 10 sec

const BankPaymentResponse = () => {
  const payData = useMemo(() => JSON.parse(localStorage.getItem('paymentStatusData')) || {}, [])
  const location = useLocation()
  let responseString = location?.state?.response ? location?.state?.response : payData?.response
  const navigate = useNavigate()
  const [timeElapsed, setTimeElapsed] = useState(0)
  const [modalState, setModalState] = useState({
    isOpen: false,
    status: 'inprogress',
    loading: false,
  })
  const intervalRef = useRef(null)
  const { progress } = usePaymentProcessingTimer(300) // 2 minutes

  const paymentStatus = async (elapsed) => {
    try {
      const response = await post('/mutualfundservice/api/bseStar/mfUpload/paymentStatus', {
        clientCode: payData?.clientCode,
        orderNo: payData?.orderNo,
      })

      if (response.isError) {
        setModalState({
          isOpen: true,
          status: 'failure',
          loading: false,
        })
        clearInterval(intervalRef.current)
        return
      }

      const status = response?.data
      if (response?.status === 'SUCCESS') {
        if (status?.includes('AWAITING') && elapsed >= 30) {
          setModalState({
            isOpen: true,
            status: 'inprogress',
            loading: false,
          })
          clearInterval(intervalRef.current)
        }

        if (status?.includes('APPROVED')) {
          setModalState({
            isOpen: true,
            status: 'success',
            loading: false,
          })
          clearInterval(intervalRef.current)
        }
      }
    } catch (error) {
      console.log('🚀 ~ paymentStatus ~ error:', error)
    }
  }

  useEffect(() => {
    if (!location?.state) {
      intervalRef.current = setInterval(() => {
        setTimeElapsed((prev) => {
          const updated = prev + 10

          paymentStatus(updated)

          if (updated >= 300) {
            clearInterval(intervalRef.current)
            setModalState({
              isOpen: true,
              status: 'inprogress',
              loading: false,
            })
          }

          return updated
        })
      }, POLL_INTERVAL)

      return () => clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    if (location?.state) {
      const container = document.getElementById('bankPage')
      setTimeout(() => {
        const form = container?.querySelector('form[name="Bankfrm"]')
        if (form) {
          form.submit()
        }
      }, 3000)

      return () => {
        if (container?.parentNode) {
          container.parentNode.removeChild(container)
        }
      }
    }
  }, [responseString])

  const handleModalClose = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }))
    navigate('/dashboard/mutual-funds/orders')
  }

  const handleModalContinue = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }))
    navigate('/dashboard/mutual-funds/orders')
  }

  const handleModalRetry = () => {
    // Retry logic can be implemented here if needed
    navigate('/dashboard/mutual-funds')
    setModalState((prev) => ({ ...prev, isOpen: false }))
  }

  return (
    <div className='flex justify-center items-center h-screen bg-white fabits-bank-response-page'>
      {!location?.state ? (
        <div className='fabits-bank-response-card'>
          <div className='ease-in-out md:max-w-2xl m-auto flex flex-col justify-center px-2'>
            <div className='flex flex-col gap-y-12'>
              {/* <div>
            <img src={`${env.SVGS}/payment.gif`} alt='Payment Gif' className='rounded-xl' />
          </div> */}
              <div className='flex flex-col gap-y-5'>
                <div className='flex flex-col gap-y-3'>
                  <h1 className='text-2xl font-medium text-center fabits-bank-response-title'>
                    Processing Your Payment
                  </h1>
                  <p className='text-center text-secondary-700 bg-secondary-50 font-medium rounded-full text-xs leading-3 py-2 fabits-bank-response-pill'>
                    Please wait on the screen for confirmation after payment
                  </p>

                  <Progress value={progress} className='h-2 bg-primary-100' />
                </div>

                <p className='text-center text-sm font-medium text-black-400 fabits-bank-response-copy'>
                  Please wait while we process your payment. This may take 1-2 minutes.
                  <br />
                  <span className='animate-pulse'>Do not close or go back.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          id='bankPage'
          dangerouslySetInnerHTML={{ __html: responseString }}
          className='fixed top-0 left-0 right-0 bottom-0 z-[1000] bg-white h-screen w-screen'
        />
      )}

      <PaymentStatusModal
        isOpen={modalState.isOpen}
        onClose={handleModalClose}
        onContinue={handleModalContinue}
        onRetry={handleModalRetry}
        status={modalState.status}
        loading={modalState.loading}
        paymentData={{
          amount: payData?.totalAmount || '0',
          paymentMode: 'Internet Banking',
          date: new Date().toLocaleString(),
        }}
      />
    </div>
  )
}

export default BankPaymentResponse
